import React from "react";

export const BoothTwoTone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 16h18v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zm11 2h-4a1 1 0 100 2h4a1 1 0 100-2z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      d="M19 14V6h-2v8H7V6H5v8H3a1 1 0 100 2h18a1 1 0 100-2h-2z"
      opacity="0.72"
    ></path>
    <path
      fill="currentColor"
      d="M20.553 2.106A2 2 0 0018.763 1H5.25a2 2 0 00-1.785 1.099l-1.25 2.476A2 2 0 002 5.476V7l.005.15A2 2 0 004 9l.15-.005c.308-.023.597-.116.851-.263C5.334 8.488 6 7.8 6 7c0-1 0 1.465 1 1.732A2 2 0 009.995 7.15L10 7l.005.15a2 2 0 003.99 0L14 7a2 2 0 002 2l.15-.005c.308-.023.597-.116.851-.263C17.334 8.655 18 8.2 18 7c.05.49.32 1.523 1 1.732A2 2 0 0022 7V5.472a2 2 0 00-.211-.894l-1.236-2.472z"
    ></path>
  </svg>
);
